/**
 * QiblaSensorGate.jsx
 * -------------------
 * Renders either:
 *   • a red "compass not supported" strip, or
 *   • a "tap to enable compass" primary button when the browser needs an
 *     explicit permission grant (iOS 13+).
 *
 * Purely presentational.
 */
import React from 'react';
import { AlertCircle } from 'lucide-react';

export const QiblaSensorGate = ({
  unsupported,
  needPermission,
  onRequestPermission,
  textColors,
  labels, // { compassUnsupported, enableCompass }
}) => {
  if (unsupported) {
    return (
      <div
        className="flex items-center gap-2 mx-4 my-4 p-3 rounded-lg"
        style={{
          background: 'rgba(239,68,68,0.10)',
          border: '1px solid rgba(239,68,68,0.30)',
          color: textColors.primary,
        }}
      >
        <AlertCircle size={16} color="#EF4444" />
        <span className="text-sm">{labels.compassUnsupported}</span>
      </div>
    );
  }

  if (needPermission) {
    return (
      <button
        type="button"
        onClick={onRequestPermission}
        className="mx-4 my-4 px-4 py-3 rounded-xl text-heading text-sm w-[calc(100%-2rem)]"
        style={{
          background: `linear-gradient(135deg, ${textColors.accent}, ${textColors.accent}dd)`,
          color: '#0d1119',
        }}
        data-testid="qibla-enable-compass"
      >
        {labels.enableCompass}
      </button>
    );
  }

  return null;
};
